<template>
  <DashboardBlock>
    <template slot="content">
      <div class="content__profile">
        <Avatar :src="avatarSrc" class="profile__avatar" />
        <div class="profile__info">
          <span class="info__subtitle_fullname">
            {{ fullnameFromToken  }}
          </span>
          <span class="info__subtitle_role">
            {{ roleFromToken }}
          </span>
        </div>
        <router-link to="/personal_info">
          <i class="fa fa-pencil fa-fw" /> Редактировать
        </router-link>
      </div>
    </template>
  </DashboardBlock>
</template>

<script>
import DashboardBlock from '@/_shared/components/ui/DashboardBlock';
import Avatar from '@/user/features/personal-area/Avatar';
import { useTokenPayload } from '@/_shared/mixins';
export default {
  mixins: [useTokenPayload],
  components: {
    DashboardBlock,
    Avatar,
  },
  computed: {
    avatarSrc() {
      const imageName = this.imageNameFromToken;
      const url = `${process.env.MEDIA_URL}/static/users/${imageName}`;
      return url;
    },
  },
};
</script>

<style scoped>
.content__profile {
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  text-align: center;
  padding-top: 20px;
}
.profile__info {
  padding: 1em 0;
  display: inline-flex;
  flex-direction: column;
  cursor: default;
}
.info__subtitle_fullname,
.info__subtitle_role {
  font-weight: 500;
  font-size: 1.15em;
}
.info__subtitle_fullname {
  padding: 0;
  margin: 0;
}
.info__subtitle_role {
  color: #57606a;
}
</style>



// WEBPACK FOOTER //
// src/user/components/personal-area/ProfileBlock.vue